import { SignInLayoutPage } from '~/pages/signIn';

export default SignInLayoutPage;
